import { Button, Flex, Select } from "antd";
import { FC, useMemo, useState } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

type RegionsMap = Record<string, string>;

const EXCLUDE = ["Готемська обл."];

interface RegionPickerProps {
    regions?: RegionsMap | null;
    value: string;
    onChange: (regionId: string) => void;
}

export const RegionPicker: FC<RegionPickerProps> = ({
    regions,
    value,
    onChange,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const options = useMemo(
        () =>
            Object.entries(regions || {})
                .filter(([_, name]) => !EXCLUDE.includes(name))
                .map(([id, name]) => ({ value: id, label: name })),
        [regions],
    );

    const currentLabel = (value && regions?.[value]) || "—";

    return (
        <Flex justify="flex-start" align="center" gap={8}>
            <PrimaryText>Регіон:</PrimaryText>

            {isOpen ? (
                <Select
                    style={{ minWidth: 200 }}
                    options={options}
                    value={value}
                    onChange={(v) => {
                        onChange(v);
                        setIsOpen(false);
                    }}
                    autoFocus
                    optionFilterProp="label"
                    onBlur={() => setIsOpen(false)}
                    placeholder={"Оберіть регіон"}
                />
            ) : (
                <Button
                    type="text"
                    style={{ padding: 0 }}
                    onClick={() => setIsOpen(true)}
                >
                    <PrimaryText textColor="accent" underline>
                        {currentLabel}
                    </PrimaryText>
                </Button>
            )}
        </Flex>
    );
};
